function MediumEllipse() {
  return (
    <svg
      width={1215}
      height={1215}
      viewBox="0 0 1215 1215"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        style={{ mixBlendMode: "overlay" }}
        opacity="0.6"
        filter="url(#filter0_f_215_406)"
      >
        <circle cy={609} cx={609} r={209} fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_f_215_406"
          x={0}
          y={0}
          width={1218}
          height={1218}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={200}
            result="effect1_foregroundBlur_215_406"
          />
        </filter>
      </defs>
    </svg>

  );
}

export default MediumEllipse;